export default function defaultStorageConfigure() {
    // 旧皮肤部分不支持列表自定义的接口，所以前端给默认值，升级后可以让后端处理。
    const params = {height: 458, heightDiff: 495,
      columns: {
      dischargePowerTop: {hidden: true},
      dischargePowerPeak: {hidden: true},
      dischargePowerFlat: {hidden: true},
      dischargePowerValley: {hidden: true},
      chargePowerTop: {hidden: true},
      chargePowerPeak: {hidden: true},
      chargePowerFlat: {hidden: true},
      chargePowerValley: {hidden: true},
      }, aggregation: false};
    if(!localStorage.getItem('table.customized.order.energy-storage-record.list')){
      localStorage.setItem('table.customized.order.energy-storage-record.list', JSON.stringify(params));
    }
}
